<template>
    <GenericConnectedIntegrationCard
        :integration="integration"
        :providerData="providerData"
        @onIntegrationDeleted="emit('onIntegrationDeleted')"
    >
        <template #actions>
            <Button
                v-if="integration.canContinueSetup()"
                :href="providerData.redirectUrl"
                as="a"
                size="small"
                color="light"
                iconName="arrow-right"
                :iconRight="true"
            >
                Resume Setup
            </Button>
        </template>
    </GenericConnectedIntegrationCard>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import Integration from '@/App/Integration/Entity/Integration'
    import Button from '@/Shared/Component/Button.vue'
    import { type IntegrationProviderDataType } from '@/Shared/AutoGenerated/Main'
    import GenericConnectedIntegrationCard from '@/App/Integration/Component/GenericConnectedIntegrationCard.vue'

    const emit = defineEmits(['onIntegrationDeleted'])

    const props = defineProps({
        integration: {
            type: Object as PropType<Integration>,
            required: true,
        },
        providerData: {
            type: Object as PropType<IntegrationProviderDataType>,
            required: true,
        },
    })
</script>
